import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface CustomSnackbarData {
  message: string;
  action?: string;
  onActionClick?: () => void;
  icon?: string;
}

@Component({
  selector: 'custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
  standalone: false,
})
export class CustomSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: CustomSnackbarData,
    private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>
  ) {
  }

  onAction(): void {
    this.data.onActionClick?.(); // Executa callback, se houver
    this.snackBarRef.dismiss();  // Fecha o snackbar
  }
}
